// import { useMsal } from "@azure/msal-react";
// import { loginRequest } from "../AuthConfig";
// import { useLogin } from "react-admin";
 
// const MicrosoftLoginPage = () => {
//   const { instance } = useMsal();
//   const login = useLogin();
 
//   const handleLogin = async () => {
//     const result = await instance.loginPopup(loginRequest);
 
//     const tokenResponse = await instance.acquireTokenSilent({
//       ...loginRequest,
//       account: result.account,
//     });
 
//     // Store token for React-Admin
//     localStorage.setItem("access_token", tokenResponse.accessToken);
//     localStorage.setItem("user_email", result.account.username);
//     const token=tokenResponse.accessToken;
//     const email=result.account.username
//     // Tell React-Admin login succeeded
//     await login({token,email});
//   };
 
//   return (
//     <div style={{ textAlign: "center", marginTop: "120px" }}>
//       <h2>Admin Portal</h2>
//       <button onClick={handleLogin} style={{ padding: "12px 20px", fontSize: "16px" }}>
//         Sign in with Microsoft
//       </button>
//     </div>
//   );
// };
 
// export default MicrosoftLoginPage;
 
 import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../AuthConfig";

const MicrosoftLoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    // 🔁 Redirect-based login (PROD SAFE)
    await instance.loginRedirect(loginRequest);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "120px" }}>
      <h2>Admin Portal</h2>
      <button
        onClick={handleLogin}
        style={{ padding: "12px 20px", fontSize: "16px" }}
      >
        Sign in with Microsoft
      </button>
    </div>
  );
};

export default MicrosoftLoginPage;
